import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";

export function ForcePasswordChange() {
  const { refreshUser, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("Kata sandi baru minimal 8 karakter");
    if (next !== confirm) return toast.error("Konfirmasi kata sandi tidak cocok");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Kata sandi berhasil diperbarui");
      await refreshUser();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 p-4" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900 p-8 shadow-2xl">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500/15 text-amber-400">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-white">Ganti Kata Sandi</h1>
            <p className="text-sm text-slate-400">Demi keamanan, Anda wajib mengganti kata sandi sebelum melanjutkan.</p>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="text-slate-300">Kata Sandi Saat Ini</Label>
            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
                   required data-testid="fpc-current" className="mt-1 bg-slate-800 text-white border-slate-700" />
          </div>
          <div>
            <Label className="text-slate-300">Kata Sandi Baru</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)}
                   required data-testid="fpc-new" className="mt-1 bg-slate-800 text-white border-slate-700" />
          </div>
          <div>
            <Label className="text-slate-300">Konfirmasi Kata Sandi Baru</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                   required data-testid="fpc-confirm" className="mt-1 bg-slate-800 text-white border-slate-700" />
          </div>
        </div>
        <div className="mt-6 flex items-center gap-3">
          <Button type="submit" disabled={loading} data-testid="fpc-submit"
                  className="flex-1 bg-indigo-600 hover:bg-indigo-500">
            {loading ? "Menyimpan..." : "Simpan & Lanjutkan"}
          </Button>
          <Button type="button" variant="ghost" onClick={logout} data-testid="fpc-logout"
                  className="text-slate-400 hover:text-white">Keluar</Button>
        </div>
      </form>
    </div>
  );
}
